import { Link } from "react-router-dom";
import { insights } from "../data/insights";
import { getHead } from "../seo/routes";
import { Seo } from "../components/Seo";
import { PageHero, CTABand } from "../components/Blocks";
import { IconTile, INSIGHT_ICON } from "../components/Icons";
import { formatDate } from "../utils/date";

const head = getHead("/insights");

export default function InsightsIndex() {
  return (
    <>
      <Seo title={head.title} description={head.description} path="/insights" />
      <PageHero
        overline="Knowledge Base"
        title="Security Insights & Industry Guides"
        lead="Practical, Canada-specific guidance on security guard licensing, loss prevention, fire watch obligations, event security planning and site protection."
      />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="insights-directory">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {insights.map((a) => (
            <Link
              key={a.slug}
              to={`/insights/${a.slug}`}
              data-testid={`insights-page-card-${a.slug}`}
              className="group border border-white/10 bg-[#181C28] rounded-sm overflow-hidden transition-all duration-200 hover:-translate-y-1 hover:border-[#FF5500]/50"
            >
              <IconTile icon={INSIGHT_ICON} size="h-9 w-9" className="h-32 border-b border-white/10" />
              <div className="p-5">
                <p className="text-[11px] font-mono uppercase tracking-[0.2em] text-[#FF5500]">{formatDate(a.date)}</p>
                <h2 className="mt-2 font-display text-lg font-bold tracking-tight text-white group-hover:text-[#FF5500] transition-colors">{a.title}</h2>
                <p className="mt-2 text-sm text-gray-400 leading-relaxed">{a.excerpt}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>
      <CTABand title="Questions About Your Site's Security?" sub="Our dispatch team answers practical questions every day. Call or email — straight answers, no forms." />
    </>
  );
}
